var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.isClosedPage)?_c('NavHeader'):_vm._e(),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('RouterView',{key:_vm.$route.fullPath})],1),(!_vm.isClosedPage)?_c('NavFooter'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }